import { createFileRoute } from '@tanstack/react-router';

import SlideBulkModal from '../../../-components/SlideBulkModal';

export const Route = createFileRoute('/_authenticated/slideshows/$id/_content/slides/bulk')({
    component: SlideBulkModal,
});
